import React from 'react';
import { List, useTable, ShowButton } from '@refinedev/antd';
import { Table, Tag } from 'antd';
import { AdminFeedbackReportDto, FeedbackReportStatus, FeedbackReportPriority } from '@wellverse/shared-ts';
import { optionLabel, PriorityTag, statusLabel } from './labels';

/** All reports, newest first. No filters in v1. */
export const FeedbackReportList: React.FC = () => {
  const { tableProps } = useTable<AdminFeedbackReportDto>({
    resource: 'feedback-reports',
    pagination: { current: 1, pageSize: 20 },
  });

  return (
    <List resource="feedback-reports" title="Reports">
      <Table {...tableProps} rowKey="id">
        <Table.Column dataIndex="reportId" title="Report ID" />
        <Table.Column
          dataIndex="priority"
          title="Priority"
          render={(priority: FeedbackReportPriority) => <PriorityTag priority={priority} />}
        />
        <Table.Column
          dataIndex="status"
          title="Status"
          render={(status: FeedbackReportStatus) => <Tag>{statusLabel(status)}</Tag>}
        />
        <Table.Column
          dataIndex="category"
          title="Category"
          render={(category: string, record: AdminFeedbackReportDto) => (
            <>
              {optionLabel(category)}
              {record.aiArea && ` · ${optionLabel(record.aiArea)}`}
            </>
          )}
        />
        <Table.Column
          dataIndex="description"
          title="Description"
          render={(text?: string) => (text ? (text.length > 40 ? `${text.slice(0, 40)}...` : text) : '—')}
        />
        <Table.Column
          dataIndex="userName"
          title="Tester"
          render={(name: string | undefined, record: AdminFeedbackReportDto) => name ?? record.userId}
        />
        <Table.Column
          dataIndex="createdAt"
          title="Received"
          render={(date: string) => new Date(date).toLocaleString()}
        />
        <Table.Column
          title="Actions"
          dataIndex="actions"
          render={(_, record: AdminFeedbackReportDto) => (
            <ShowButton hideText size="small" recordItemId={record.id} resource="feedback-reports" />
          )}
        />
      </Table>
    </List>
  );
};
